const getConsole = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window['console'];
};

const logger = {
  debug: (...args) => {
    if (process.env.NODE_ENV !== 'production') {
      getConsole()?.debug?.(...args);
    }
  },
  info: (...args) => {
    if (process.env.NODE_ENV !== 'production') {
      getConsole()?.info?.(...args);
    }
  },
  warn: (...args) => {
    if (process.env.NODE_ENV !== 'production') {
      getConsole()?.warn?.(...args);
    }
  },
  error: (...args) => {
    if (process.env.NODE_ENV !== 'production') {
      getConsole()?.error?.(...args);
    }
  }
};

export default logger;
